import type { IconSvgObject } from './types';

const IterationCcwIcon: IconSvgObject = [
  ["path", { d: "M20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 7.58172 18 12 18H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 14C16 14 20 16.946 20 18C20 19.0541 16 22 16 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default IterationCcwIcon;
